__turbopack_context__.v({
  "button": "hours-visual-module__0pZk2W__button",
  "buttonDone": "hours-visual-module__0pZk2W__buttonDone",
  "calendar": "hours-visual-module__0pZk2W__calendar",
  "dayCell": "hours-visual-module__0pZk2W__dayCell",
  "dayCellFlash": "hours-visual-module__0pZk2W__dayCellFlash",
  "dayCellRing": "hours-visual-module__0pZk2W__dayCellRing",
  "dayHours": "hours-visual-module__0pZk2W__dayHours",
  "dayHoursFlash": "hours-visual-module__0pZk2W__dayHoursFlash",
  "dropdown": "hours-visual-module__0pZk2W__dropdown",
  "dropdownRow": "hours-visual-module__0pZk2W__dropdownRow",
  "dropdownRowActive": "hours-visual-module__0pZk2W__dropdownRowActive",
  "dropdownVisible": "hours-visual-module__0pZk2W__dropdownVisible",
  "hoursFlash": "hours-visual-module__0pZk2W__hoursFlash",
  "hoursValuePop": "hours-visual-module__0pZk2W__hoursValuePop",
  "modal": "hours-visual-module__0pZk2W__modal",
  "root": "hours-visual-module__0pZk2W__root",
  "scrim": "hours-visual-module__0pZk2W__scrim",
  "scrimVisible": "hours-visual-module__0pZk2W__scrimVisible",
});
